import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"edit\">\n  <path fill-rule=\"evenodd\" d=\"M344.214,104.659l2.036,2.046-5.155,5.181-2.035-2.046Zm3.582-.494-0.909-.913a0.9,0.9,0,0,0-1.273,0l-0.87.875,2.037,2.046,1.015-1.019a0.7,0.7,0,0,0,0-.989h0Zm-9.8,8.551a0.232,0.232,0,0,0,.281.277l2.269-.553-2.035-2.046Zm0,0\" transform=\"translate(-338 -103)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/edit.svg
// module id = null
// module chunks = 